import React, { useEffect, useState } from "react";
import client, { apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Drawer, Empty } from "../team/shared";

export function AssignLeads({ members, onClose, onDone }) {
  const [leads, setLeads] = useState(null);
  const [sel, setSel] = useState([]);
  const [mid, setMid] = useState(members[0]?.id || "");
  useEffect(() => { client.get("/partners-leads/unassigned").then(({ data }) => setLeads(data)).catch(() => setLeads([])); }, []);
  const toggle = (id) => setSel(sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id]);
  const assign = async () => {
    if (!mid || !sel.length) { toast.error("Partner aur leads select karein"); return; }
    try { const { data } = await client.post("/partners-leads/assign", { lead_ids: sel, member_id: mid }); toast.success(`${data.updated} leads assigned`); onDone(); } catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <Drawer title="Assign Leads" onClose={onClose} testid="assign-drawer">
      <select data-testid="assign-member" value={mid} onChange={(e) => setMid(e.target.value)} className="w-full mb-3 bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-3 py-2 text-sm text-white">
        {members.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
      </select>
      <div className="max-h-[60vh] overflow-y-auto surface mb-4">
        {!leads ? null : leads.length === 0 ? <Empty text="Saari leads already assigned hain." /> : leads.map((l) => (
          <label key={l.id} data-testid={`assign-lead-${l.id}`} className="flex items-center gap-2 px-3 py-2 border-b border-[color:var(--border-subtle)] cursor-pointer hover:bg-white/5">
            <input type="checkbox" checked={sel.includes(l.id)} onChange={() => toggle(l.id)} className="accent-[color:var(--gold)]" />
            <span className="text-sm text-white">{l.name}</span><span className="text-xs text-slate-500 ml-auto">{l.status}</span>
          </label>
        ))}
      </div>
      <button data-testid="assign-submit-btn" onClick={assign} className="btn-gold w-full py-2.5 text-sm">Assign {sel.length || ""} Leads</button>
    </Drawer>
  );
}
